export default "__VITE_ASSET__CzOUT1JE__"